import React from "react";
import i18n from "i18n";
import { Image } from "react-bootstrap";
import { images } from "assets/images";
import {
  ReportsStatusTypes,
  moreDataServerTypes,
} from "pages/Dashboards/OnlineDashboard/types";
import { ReportsCompletedByRoles } from "pages/Dashboards/types";
import { ChartDataGetter } from "./types";

export const getReportsStatusDataArray = (
  ReportsStatusData: ReportsStatusTypes
) => [
  {
    amount: ReportsStatusData?.inProgress,
    title: i18n.t("totalReportsToComplete"),
    icon: (
      <Image src={images.clipboard} width={22} height={27} color="#70edd7" />
    ),
  },
  {
    amount: ReportsStatusData?.waitingForLetterToSent,
    title: i18n.t("waitingForLetter"),
    icon: (
      <Image src={images.envelope} width={28} height={23} color="#ed6666" />
    ),
  },
  {
    amount: ReportsStatusData?.waitingPackingForPolice,
    title: i18n.t("waitingForPacking"),
    icon: (
      <Image
        src={images.shieldExclamation}
        width={25}
        height={28}
        color="#7084ed"
      />
    ),
  },
  {
    amount: ReportsStatusData?.otherReports,
    title: i18n.t("otherReports"),
    icon: <Image src={images.chat} width={28} height={26} />,
  },
];

export const getMoreDataArray = (moreData: moreDataServerTypes) => [
  {
    ...moreData.reportsSentByVolunteers,
    text: i18n.t("sentByvolunteerToday"),
    icon: (
      <Image
        src={images.chatExclamation}
        width={28}
        height={26}
        color="#7084ed"
      />
    ),
  },
  {
    ...moreData.volunteersThatSentToday,
    text: i18n.t("volunteerReportedToday"),
    icon: <Image src={images.person} width={27} height={27} color="#ed6666" />,
  },
  {
    ...moreData.controllersConnected,
    text: i18n.t("controllersConnectedToday"),
    icon: (
      <Image src={images.controller} width={27} height={27} color="#116486" />
    ),
  },
];

export const getReportsCompletedDataArray = (
  reportsCompletedData: ReportsCompletedByRoles
) => [
  {
    reporterTitle: i18n.t("controlCenter"),
    notCompletedColor: "#70edd7",
    dataByController: { ...reportsCompletedData.controlCenter },
  },
  {
    reporterTitle: i18n.t("regularControllers"),
    notCompletedColor: "#ed6666",
    dataByController: { ...reportsCompletedData.regularController },
  },
  {
    reporterTitle: i18n.t("seniorControllers"),
    notCompletedColor: "#7084ed",
    dataByController: { ...reportsCompletedData.seniorController },
  },
];

export const getChartDataArray: ChartDataGetter = (
  data,
  valueProperty,
  namePrefix
) => [
  {
    name: `${namePrefix}True`,
    value: data[valueProperty],
    fill: "#040b44",
  },
  {
    name: `${namePrefix}False`,
    value: 100 - data[valueProperty],
    fill: "#e6e8ef",
  },
];

export const getReportCompletedChartDataArray = (
  completed: number,
  notCompleted: number,
  notCompletedColor: string
) => [
  {
    name: "completed",
    value: completed,
    fill: "#040b44",
  },
  {
    name: "notCompleted",
    value: notCompleted,
    fill: notCompletedColor,
  },
];
